module.exports = "mat-panel-description {\n  color: black; }\n\n.w-130 {\n  width: 130px; }\n"